import React from 'react';

export function Badge({ children, tone = 'dark', className = '' }) {
  const classes = ['ds-badge', `ds-badge--${tone}`, className].filter(Boolean).join(' ');
  return <span className={classes}>{children}</span>;
}

export function StatusDot({ label, tone = 'pending', className = '' }) {
  return (
    <span className={`ds-status-dot ${className}`.trim()}>
      <span className={`ds-status-dot__mark ds-status-dot__mark--${tone}`} aria-hidden />
      {label}
    </span>
  );
}

export default Badge;
